import { replica } from '@/shared/sync/replica';
import { tokenStorage } from '@/shared/sync/token-storage';
import { deviceName } from '../helpers/device-name';
import { sessionStore } from '../lib/session-store';
import { type StoredSession, storedSessionSchema } from '../schemas/stored-session';

/** `login` is the username or the email address. */
export async function signIn(login: string, password: string): Promise<StoredSession> {
  const body = await replica.http.json<unknown>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ login, password, device_name: deviceName() }),
  });
  const session = storedSessionSchema.parse(body);
  // The token is not part of the stored profile: it has its own storage.
  tokenStorage.set((body as { token: string }).token);
  sessionStore.write(session);
  replica.engine.resume();
  return session;
}
